import { COLORS } from '@/styles/colors';
import { flex } from '@/styles/layout';
import { media } from '@/styles/responsive';
import { bodySmall, poppinsMediumFont, poppinsRegularFont, subTitle } from '@/styles/typography';
import styled from 'styled-components';

export const ViewPaymentDetailsContainer = styled.div`
  width: 100%;
  ${flex({ alignItems: 'center', justifyContent: 'space-between' })}
  padding: 28px;
  border: 1px solid ${COLORS.grey[400]};
  border-radius: 20px;
  background-color: ${COLORS.white};

  ${media.mobile`
    ${flex({ flexDirection: 'column' })};
    padding: 16px;
    row-gap: 10px;
  `}
`;

export const ViewPaymentDetailsHeader = styled.div`
  ${poppinsMediumFont};
  ${subTitle};
  color: ${COLORS.grey[900]};
`;

export const ViewPaymentDetailsText = styled.div`
  ${poppinsRegularFont};
  ${bodySmall};
  color: ${COLORS.grey[600]};
`;
